import me from "../bg-about.jpg"
//import { useRef } from "react"
import { FaPhone,FaEnvelope,FaLocationArrow } from 'react-icons/fa';
import './contact.css';
import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
const Contact = () => {
  const formRef = React.createRef();
  const [done, setDone] = useState(false)
  
  const handleSubmit = (e) =>
  {
    e.preventDefault();
    emailjs.sendForm('service_k7frtwb', 'template_r1w3cya', formRef.current, 'user_giPYwiPAtP61Xxr7yNFPu')
      .then((result) => {
        console.log(result.text);
        setDone(true)
      }, (error) => {
          console.log(error.text);
      });
    }
  return (
    <>
      <div className="c" id = "contact">
        <div className="c-bg"></div>
        <div className="c-wrapper">
          <div className="c-left">
            <h1 className="c-title">Let's content!</h1>
            <div className="c-info">
              <div className="c-info-item">
              <FaPhone className="c-icon"/>
              <a href="tel:+1 972 799 6521">+1 972 799 6521</a>
              </div>
              <div className="c-info-item">
              <FaEnvelope className="c-icon"></FaEnvelope>
              <a href="mailto:anirudh.thakur94@gmail.com">anirudh.thakur94@gmail.com</a>
              </div>
              <div className="c-info-item">
              <FaLocationArrow className="c-icon"></FaLocationArrow>
              <a href="https://goo.gl/maps/wN45SJEx2oSEJoZK8">Richardson,Texas </a>
              </div>
              </div>
          </div>
          <div className="c-right">
            <p className="c-desc">
              Open to feedback on anything. Would be happy to help if you need any assistant to understand any of my work.
            </p>
            <form ref = {formRef} onSubmit={handleSubmit}>
              <input type="text"  class="form-control" placeholder="name" name="user_name"></input><br></br>
              <input type="text" class="form-control"  placeholder="subject" name="user_subject"></input><br></br>
              <input type="text"  class="form-control" placeholder="email address" name="user_email"></input><br></br>
              <textarea rows="5" class="form-control" placeholder="message" name="message"></textarea> <br></br>
              <button class="btn btn-success">Submit</button>
              {done && "Thank you for reaching out"}
            </form>
          </div>
        </div>
      </div>
    </>
  )
}
export default Contact